


































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { QUANTITY_FORMAT } from '@/helpers/currency';
import { DxLookup, DxScrollView, DxSwitch } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import notificationService from '@/services/notificationService';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';
import { ArticleStatus, IArticle } from '@/data/web-api-client';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxLookup,
    DxScrollView,
    DxRequiredRule,
    DxSwitch,
  },
})
export default class AddArticleDialog extends Vue {
  public show: boolean = false;
  public updating: boolean = false;
  public formdata: {
    articleId: string;
    quantity: number;
  } = {
    articleId: '',
    quantity: 0,
  };
  hideInactiveArticles: boolean = true;

  addArticle() {
    try {
      const validationResult = (this.$refs.form as any).instance.validate();
      if (validationResult.isValid) {
        const article = this.articles.find((o) => o.id === this.formdata.articleId);
        if (!article) {
          throw Error('article is undefined');
        }

        this.$emit('add', { article, data: this.formdata });
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  get articleLookupOptions() {
    return {
      dataSource: this.articles,
      displayExpr: (value: IArticle) => {
        if (!value) {
          return null;
        }

        return value.name + ' - ' + value.description;
      },
      valueExpr: 'id',
      searchEnabled: true,
    };
  }

  get articles(): IArticle[] {
    const articles: IArticle[] = this.$store.getters['articles/items'];
    if (this.hideInactiveArticles) {
      return articles.filter((o) => o.status === ArticleStatus.Active);
    }

    return articles;
  }
}
